import axios from "axios";
import { useAuth } from "../../provider/authContextType";
import { useQuery } from "@tanstack/react-query";

const fetchPreexistence = async (origin: string | null, codeMember: string, identityDocumentTypeId: number, identityDocument: number) => {
    const response = await axios.get(
        `${origin}/affiliation/getPreexistenceByCodeMember`,
        {
            params: {
                codeMember: codeMember,
                identityDocumentTypeId: identityDocumentTypeId,
                identityDocument: identityDocument
            },headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer`,
            },
        }
    );
    return response.data;
};

export const useFetchPreexistence = (identityDocumentTypeId: number, identityDocument: number, codeMember: string) => {
    const { origin } = useAuth();
    return useQuery({
        queryKey: ['preexistence', codeMember],
        queryFn: () => {
            return fetchPreexistence(origin, codeMember, identityDocumentTypeId, identityDocument);
        },
        staleTime: 1000 * 60 * 10,
    });
};